import React from "react";
import ScopeStackModal from "../ScopeStackModal/ScopeStackModal";
import { FileUploadDragAndDrop } from "@components/FormsV2/FileUploadDragAndDrop";
import fileToBase64 from "@utils/fileToBase64";
import { saveErrorReason } from "@components/CatalogIndex";
import { useV2CreateDataImportMutation, V2DataImportResource } from "@generated";

function DataImportModal({
  account,
  projectId,
  modalTitle,
  importType,
  contextType,
  contextId,
  importInstructions,
  setErrorMessage,
  setLoadingIndicator,
  setShowFailAlert,
  setShowDataImportModal,
  showDataImportModal = false,
}) {
  const [createDataImport] = useV2CreateDataImportMutation();
  const appHost = process.env.REACT_APP_DOORKEEPER_APP_URL;

  const handleFileSelect = async (file: File) => {
    if (file) {
      const encodedFile = await fileToBase64(file);

      const accountId = account?.data?.attributes?.["account-id"];
      if (!accountId) return;
      const importData: V2DataImportResource = {
        type: "data-imports",
        attributes: {
          "import-type": importType,
          "context-type": contextType,
          "context-id": contextId.toString(),
          "data-file": encodedFile,
        },
        relationships: {
          account: {
            data: {
              type: "accounts",
              id: String(accountId),
            },
          },
        },
      };

      if (encodedFile) {
        setLoadingIndicator(true);
        createDataImport({
          body: { data: importData },
        })
          .unwrap()
          .then((res) => {
            const importId = res.data?.id;
            setShowDataImportModal(false);
            window.location.replace(
              `${appHost}/projects/${projectId}/project_imports/${importId}/edit`
            );
          })
          .catch((error) => {
            setLoadingIndicator(false);
            setErrorMessage(
              saveErrorReason(error) ??
                "Could not start the import. Please check the file and try again."
            );
            setShowFailAlert(true);
          });
      }
    }
  }

  return (
    <>
      <ScopeStackModal
        modalTitle={modalTitle}
        modalBody={
          <div>
            <div className="instructionalText seafoamText bold">
              {importInstructions}
            </div>
            <FileUploadDragAndDrop handleFileSelect={handleFileSelect} />
          </div>
        }
        button1Text="Cancel"
        handleButton1Click={() => setShowDataImportModal(false)}
        button2Text={null}
        handleButton2Click={() => null}
        show={showDataImportModal}
        handleClose={() => setShowDataImportModal(false)}
      />
    </>
  );
}

export default DataImportModal;
